import Vue from 'vue'
// import Vant from 'vant'
import 'normalize.css' // A modern alternative to CSS resets

import App from './App.vue'
import '@/utils/wxConfig'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import './lazyload/index'

import '@/utils/permission' // permission control

import './assets/css/base.less'
// import '../node_modules/vant/packages/vant-css/src/base.css'
import i18n from './lang' // Internationalization
import { Dialog } from 'vant'
// dayjs load utc plugin
dayjs.extend(utc)
dayjs.extend(customParseFormat)
Vue.use(Dialog)

Vue.use({
  i18n: (key, value) => i18n.t(key, value)
})

Vue.filter('toLocalTime', function(value) {
  return dayjs
    .utc(value, 'YYYY-MM-DD HH:mm:ss')
    .local()
    .format('YYYY-MM-DD HH:mm:ss')
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
